//Copyright © Northstar Travel Media, LLC. All Rights Reserved - code may not be reused in whole or in part without written consent- removal of this section consitutes a copyright violation
var aview = 'D'; var sort = ""; var sorta = false; var nPerPage = 20; var nCPG = 1; var bIsHistory = false; var bCheckedHistory = false; var dataTry = 0; var rTitle = ''; var rSubTitle = '';var bInteractive = false; 
var pnlListing;var pnlListTitle;var pks = new Array();var sf= new Array();var intSFvs=0;var bMapView=false;var bCompareView=false;var bAllowCompare=true;
var bInitload = false; var bCanRefresh = false;var bLoading=bMapView;var expndmi=2;var rhtml='';var phtml='';var chtml='';var rcnt;var destkeys='';
var oSearch; var baseURL = ''; var oState; var sid = ''; var selcmp = '|'; var dn = '';  var cpgk = 0; var bUseBounds = false; 
var baseKey = 0; var baseLat = -999; var baseLong = -999; var baseMapLat = -999;; var baseMapLong = -999; var bLastDest = ""; var bApplySTT = true; var sAKW = ""; var cURL = "";

function HasAMap() {return false;}
function drpSel(a, l) { trackView('Filter' + l, a.options[a.selectedIndex].text, '', true, true); resetMap() }
function drpSelV(a, l) {  trackView('Filter' + l, a, '', true, true); resetMap() }
function getListval(listname) {
    var v = $("#" + listname).find("input:checked").val();
    if (v == undefined || v == null) { v = "";}
    return v;
}
function getListtext(listname) {
    var v = $("#" + listname).find("input:checked").next().html();
    if (v == undefined || v == null) { v = "" }
    return v;
}
function resetMap() {nCPG = 1; saveState(false); mGetPinData();}
 function trackView(action, label, value, pageview, refads) {
     if (baseURL!='' && pageview){
        var myurl=baseURL
        var s=parmstring();     
        if (s!=''){myurl=appndURL(myurl,s)}
        if (bCompareView){myurl=appndURL(myurl,"cmp=1")}
        myTrackPageView(myurl, refads, action)
        }        
    myTrackEvent('ResNav',action,label, value)
}
function resetPgTitle(elm) {
    var e = $(elm);
    if (e.length > 0 && e.html().length > 0) {
        var v = e.html();
        if (v.indexOf('- Page') > 0) { e.html(v.substring(0, v.indexOf('- Page'))); } 
    }
    
}
function mGetPinData(){if(bLoading){return};GetPinData()}

function GetHotelMapData() {
    if (oSearch) {
        oSearch.View = "M2";
        var DTO = { 'oSearch': oSearch, 'MapView': bMapView, 'CompareView': false, 'AdKeyword': sAKW };
        DynaProxy.invoke("GetHotelPoints", DTO, function (data) { parseRes(data, "HOTM") }, AjaxFailed)
    }
}

function GetHotelPinData() {
    if (oSearch) {
        clrRes();
        
        cURL = location.href;
        if (cURL.indexOf("&pg=") > 0) { cURL = cURL.substring(0, cURL.indexOf("&pg=")); }
        if (cURL.indexOf("?pg=") > 0) { cURL = cURL.substring(0, cURL.indexOf("?pg=")); }
        if (nCPG > 1) { cURL = cURL + (cURL.indexOf("?")>0? "&":"?") + "pg=" + nCPG; }
        var title = document.title;
        if (title.indexOf("| Page") > 0) { title = title.substring(0, title.indexOf("| Page")); }
        if (nCPG > 1) { title = title + " | Page " + nCPG; }        
        history.pushState({ Title: title }, title, cURL);    

        resetPgTitle($('[data-page-title]'));
        resetPgTitle($(".navbar-title span"));


        var DTO = { 'oSearch': oSearch, 'MapView': bMapView, 'CompareView': false,'AdKeyword':sAKW };
        DynaProxy.invoke("GetHotelPoints", DTO, function(data) { parseRes(data, "HOT") }, AjaxFailed)        
    } 
}
function GetSeeDoPinData() {
    if (oSearch) {
         var DTO = { 'oSearch': oSearch};
         DynaProxy.invoke("GetSeeDoPoints", DTO, function(data) { parseRes(data, "SNDO") }, AjaxFailed)
    }
}
function GetAirportPinData() {
    if (oSearch) {       
        var DTO = { 'oSearch': oSearch };
        DynaProxy.invoke("GetAirportPoints", DTO, function (data) { parseRes(data, "APT"); }, AjaxFailed)
    }
}

function initPins() {
    if (aview == "D") {
        saveState(false); GetHotelMapData();
    } else if (aview=="H") {
    } else {
       resetMap();
   }
}
function encodedBaseCtr(){var s=''; try{s='#'+ baseLat + '#' + baseLong}catch(e){};return s }

function parseRes(r, a) {

    if (a == "HOTM") { 
        Northstar.maps.addMarkers(r.JSONMapItems, true);
        bSetPts = false;
    } else {
        rotateads()
        rcnt = numberWithCommas(r.ResultCount); rhtml = r.HTMLList; chtml = r.HTMLCount; phtml = r.HTMLPages; rTitle = r.Title; rSubTitle = r.SubTitle;
        sf = new Array(); sf = r.FlagsString.split("|");
        fInitFilterflags(r);
        wr = r.WithReview; mypts = new Array();

        if (oSearch.CurrentPage > 1) {
            $("#resCount").html(r.HTMLCount);
            $(".venue-show-more").remove();
            $("#resList").find("article:last").after(r.HTMLList);
            Northstar.venueSearch.resizeMap()
        } else {
            $("#resCount").html(r.HTMLCount);
            $("#resList").html(r.HTMLList);
        }

        if (r.AdImpressions != "" && r.AdImpressions != null) { $("#aim").html(r.AdImpressions); }        
       // $('.slider-simple:not(.slick-initialized)').slick();
        initResults()

        if (oSearch.CurrentPage == 1 && HasAMap() && r.JSONMapItems != "") {
            Northstar.maps.addMarkers(r.JSONMapItems, true);
            bSetPts = false;
        }
        
        bInitload = false; bCanRefresh = true; try { saveState(true) } catch (e) { }; bIsHistory = false;
        r = null
    }
    
}

function parseNB(r, a) {

    var ly;eval('ly=bSR' + a)  
    if (!ly) { ly = []; }
    eval('bSR' + a + '=ly');dataTry =0; pins = new Array();mypts=new Array();
   
    for (x = 0; x < r.Items.length; x++) {
        var oLoc=r.Items[x];
        var pin = new _pinFromLoc(oLoc)
        if (!pin.base){
            pin.near = true
            if (pin.locs.latitude != -999) {
                var sTitle = oLoc.PlaceName + "\n" + oLoc.Address
                var ico = "/dist/images/p/" + a + ".png";
                var marker = new google.maps.Marker({ position: pin.locs, map: map, icon: ico, title: sTitle });
                ly.push(marker);
            }           
        }
    }
    eval('bSR' + a + '=ly')
    if (a == 'APT') {
        if (r.MinLong > -999) {
            mypts.push(new google.maps.LatLng(r.MinLat, r.MinLong));
            mypts.push(new google.maps.LatLng(r.MaxLat, r.MaxLong))
            setView(mypts)
        }        
    }

    r=null      
}

function clrRes() {if (!bInitload && !bIsHistory && !bMapView) {$(".results-list").css({ opacity: 0.3 });}}
function mShowPagedResults2() {
    $("#resList").html(rhtml);rhtml = null; rcnt = null;
    if (rTitle != '' && rTitle != null) {
        $(".my-page-title").text(rTitle)
        document.title = rTitle ; 
    }
    rSubTitle = null; rTitle = null;
    $(".pagination").html(phtml); $(".toolbar .results").html(chtml); phtml = null; chtml = null    
    if (!bMapView) {
	    if (!isScrolledIntoView($('#list-top'))) { $(document).scrollTop($('#list-top').offset().top) }
	    $(".results-list").css('opacity', '');
    }
}

function mShowPagedResults() { mShowPins() }
function defaultsort(s) {
    if (s == 'mtgspc' || s == 'room' || s == 'cls' || s == 'mtglsize' || s == 'mtgrm' || s == 'rating' ) { return "desc" } else { return "asc" }

}
function onlistsort() {	
    var s = $("#drpHotelSort").val();
    ord = defaultsort(s);
    if (sorta!= (ord=="asc") || s!=sort){
	    sorta = ord=="asc"
        sort = s;
        trackView('FilterSort', sort + '_Asc:' + sorta.toString(), '', true, false);
        resetMap();
    }
}
function saveState(pgst) {
	if (!bIsHistory && !bInitload) {
	    oSearch=new _srchst();
        if (oSearch) {
            if ($("#myMapHolder").length > 0) {
                $("#myMapHolder").append($("#myMap"))
            }
            if (historyStorage) {
            	historyStorage.remove("osrch"); historyStorage.put("osrch", oSearch);
            	if (pgst) { oState = new _pgstate(); historyStorage.remove("ostate"); historyStorage.put("ostate", oState) }
            }
        }
  }
} 

function dhtmlisten (newLocation, historyData){oSearch = historyStorage.get("osrch"); oState= historyStorage.get("ostate");restoreState()}  
function initdhtml(){window.dhtmlHistory.create({toJSON: function(o) {return JSON.stringify(o);},  fromJSON: function(s) {   return JSON.parse(s);}});window.onload = initdhtml_f}     
function initdhtml_f() {  dhtmlHistory.initialize(); dhtmlHistory.addListener(dhtmlisten); bCheckedHistory = true; }

function _pgstate() {

    if (HasAMap()) {
	    this.mapcenter = map.getCenter()
	    this.zoom =parseInt( map.getZoom())
		baseMapLat = this.mapcenter.latitude
		baseMapLong = this.mapcenter.longitude
		baseZoom = this.zoom
		
		
	}
    this.destkeys=destkeys;
    this.baseKey=baseKey;
    this.address=dn;
    return this
}

function _gsrchst(b) {
    
    var nMiles=0
    var d="";     
    if (destkeys!=''){d=destkeys}else{d=baseKey}   
    b.SessionID=ccar;
    b.PageKey=cpgk;
    b.RequestURL= baseURL;
    b.DestinationPlacekeys=d;
    b.SearchRadius= nMiles;
    b.CurrentPage = nCPG;
    b.View = aview;
    b.SortField =sort
    b.SortAscending = sorta
    b.Placekeys =pks
    b.ReturnMapData = HasAMap()
    b.SearchId=sid;
    b.Selected=selcmp;
    b.AllowCompare=bAllowCompare
    b.Center=encodedBaseCtr()    
    b.UseBounds=bUseBounds; 
    b.ProcessSTTItems = bApplySTT;

    if (HasAMap()) {
       var mapView = map.getBounds(); 
        b.MapZoom = parseInt(map.getZoom());
        b.MapWidth =map.getDiv().clientWidth;
        b.MapHeight =  map.getDiv().clientHeight;
        b.SearchBounds = GetBounds();
        baseZoom = b.MapZoom

    	    }
    return b
}

function grestoreState() {

        if (oState){
             bIsHistory=true  
            if ( oState.MyResultsPage!=''){
                $(".browse-results-nav").find(".c-01-count").html(oState.MyCount)
                $(".browse-results-nav").children(".c-02").html(oState.MyResultsPage)
                $(".browse-results-nav").children(".c-02a").html(oState.MyResultsPage2)
                sf=oState.sf        
                destkeys=oState.destkeys
                baseKey=oState.baseKey
                dn=oState.address
            }
            
        }
        if (oSearch){
            destkeys = oSearch.DestinationPlacekeys;
            
            
            nCPG = oSearch.CurrentPage    
            aview = oSearch.View
            sort=oSearch.SortField
            sorta=oSearch.SortAscending  
            pks=oSearch.Placekeys 
           // bMapView=oSearch.ReturnMapData
            selcmp=oSearch.Selected; 
            sid=oSearch.SearchId;            
            cpgk=oSearch.PageKey;
            ccar=oSearch.SessionID;
            bApplySTT=oSearch.ProcessSTTItems;
            bAllowCompare=oSearch.AllowCompare;
            bUseBounds=oSearch.UseBounds 
            if (oSearch.Center!=''){
                baseLat =oSearch.Center.split('#')[1]
                baseLong=oSearch.Center.split('#')[2]
            }
            if(bMapView){
                    
                baseZoom=oState.zoom
                baseMapLat =oState.mapcenter.latitude
                baseMapLong=oState.mapcenter.longitude
                              
              try{
                  if (map) {
                    map.setView({ center: new google.maps.LatLng(baseMapLat, baseMapLong), zoom: baseZoom })
                    try{initBase();}catch(e){};  
              }  
               }catch(e) {}
        }
          if(bIsHistory){ mGetPinData();}
     }
           
   }

function initResults() {
    
   	$(".namelink[_aid]").click(function () {
        var n= $(this).parents(".result").index()+1
        var s = "/ad?aid=" + $(this).attr("_aid") + "&ctu=" + escape($(this).attr("href")) + "&pgk=" + cpgk + "&pos="+ n.toString() + "&rfu=" + escape(window.location.href)
        winloc(s)
        return false;
    });

    typeinitResults()
}




function swapView(url) { saveState(); var s = parmstring(); if (s != '') { url = appndURL(url, s) }; winloc(url) }

$(document).ready(function () {
   
    $(document).on("click", ".venue-show-more", function () { 
        
        var s = parseInt($(this).attr("_p")); bApplySTT = false;
        if (s != nCPG && s != 0) {
            trackView('FilterPage', s, '', true, false); nCPG = s;
            try { saveState(false) } catch (e) { }; mGetPinData(false);
        }

        return false;
    });

    initResults();
    $("#drpHotelSort").change(function () { onlistsort(); })   

    $(document).on("click", ".venue-view a",function () {

        
        var thisview = $(this).attr("_view");
        if (thisview == aview && $(this).hasClass("active")) { return false; }
        
        aview = thisview;
        if (aview == "M") { $(".venue-list-wrapper").removeClass("view-list").addClass("fullsize-map").removeClass("view-gallery") }
        else if (aview == "L") { $(".venue-list-wrapper").addClass("view-gallery").removeClass("fullsize-map").removeClass("view-list") }
        else { $(".venue-list-wrapper").addClass("view-list").removeClass("fullsize-map").removeClass("view-gallery") }

        $(".venue-view a").removeClass("active")
        $(this).addClass('active')
        trackView('SwitchView', aview, '', true, false);       
        resetMap()

        return false;
    });

   
    $(document).on('click touchstart', 'body', function (e) {
        var preview = $(this).find(".venue-card.preview");
        if (preview.length) {
            preview.hide();
            $('.find-venue-results').removeClass('disabled')
        }
    });

    $(document).on('click', '.view-gallery .venue-preview', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        var venuecard = $(this).closest('.venue-card:not(.preview)');
        var preview = venuecard.find(".venue-card.preview");         
        if (preview.length)
        {
            preview.show();
        }    
        else{
            preview = venuecard.clone();
            venuecard.append(preview.addClass('preview'));
        }
        preview.on('click touchstart', function (e) {
            e.stopPropagation();
        });
        
        var cmp = preview.find('.cmp-venue').first();
        cmp.off().on('click touchstart', function (e) { 
            venuecard.find('.cmp-venue').first().click();
            return false;
        });

        var addcollection = preview.find('.add-to-collection').first();
        addcollection.off().on('click touchstart', function (e) { 
            venuecard.find('.add-to-collection').first().click();
            return false;
        });

        var gatecollection = preview.find('.gate-collection').first();
        gatecollection.off().on('click touchstart', function (e) {
            venuecard.find('.gate-collection').first().click();
            return false;
        });

        $('.find-venue-results').addClass('disabled');;
        Northstar.venuePreviews.position();

        return false;
    });

    $('.view-gallery .d-none.d-lg-block').addClass('w-100');

});